// Environment configuration (Vite)
// Vite exposes env via import.meta.env and only variables prefixed with VITE_
const isDevelopment = import.meta.env.MODE === 'development';
// Playwright and firebase.js use VITE_USE_EMULATORS (plural); accept both spellings.
const useEmulator =
  (import.meta.env.VITE_USE_EMULATORS || import.meta.env.VITE_USE_EMULATOR || 'false') === 'true';

// Prefer env overrides if provided.
// Emulator base must include project + region so axios `/fn` hits the right path.
export const FIREBASE_FUNCTIONS_URL = useEmulator
  ? (import.meta.env.VITE_FUNCTIONS_URL_EMULATOR ||
      'http://127.0.0.1:5001/quantum-flo-auto-algo-d3c2b/us-central1')
  : (import.meta.env.VITE_FUNCTIONS_URL || 'https://us-central1-quantum-flo-auto-algo-d3c2b.cloudfunctions.net');

export const config = {
  isDevelopment,
  useEmulator,
  functionsUrl: FIREBASE_FUNCTIONS_URL
};

export default config;